import type {App} from "vue"
import {use, init, type ECharts, type ComposeOption, graphic} from "echarts/core"
import {PieChart, type PieSeriesOption, BarChart, type BarSeriesOption} from "echarts/charts"
import {
  TooltipComponent,
  LegendComponent,
  GridComponent,
  type TooltipComponentOption,
  type LegendComponentOption,
} from "echarts/components"
import {LabelLayout} from "echarts/features"
import {CanvasRenderer} from "echarts/renderers"

// реєструємо тільки потрібні модулі
use([
  PieChart,
  TooltipComponent,
  LegendComponent,
  LabelLayout,
  CanvasRenderer,
  GridComponent,
  BarChart,
])

export type EC = ECharts
export type ECOption = ComposeOption<
  PieSeriesOption | TooltipComponentOption | LegendComponentOption | BarSeriesOption
>

type Renderer = "canvas" | "svg"
export interface EChartsAPI {
  init: (
    el: HTMLDivElement,
    theme?: string | object,
    opts?: {renderer?: Renderer; useDirtyRect?: boolean}
  ) => EC
  graphic: typeof graphic
}

export default {
  install(app: App) {
    const api: EChartsAPI = {init, graphic}
    app.provide("echarts", api)
    app.config.globalProperties.$echarts = api
  },
}
